import { Component, inject, Input, OnChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import CustomStore from 'devextreme/data/custom_store';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { HttpErrorResponse } from '@angular/common/http';
import { GestArticoliBaseComponent } from '../../gest-articoli-base/gest-articoli-base.component';
import { AllegatiDipendentiService } from 'src/app/shared/services/allegati-dipendenti.service';
import { AllegatiDipendenti } from 'src/app/models/allegati-dipendenti';
import * as FileSaver from 'file-saver';
import { PopupAddAllegatoDipendenteComponent } from '../../popups/popup-add-allegato-dipendente/popup-add-allegato-dipendente.component';
import { Dipendente } from 'src/app/models/dipendente';
import {
  DxPopupComponent,
  DxDataGridComponent,
  DxTemplateDirective,
} from 'devextreme-angular';
import {
  DxiColumnComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { firstValueFrom } from 'rxjs';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';

@Component({
  selector: 'app-grid-allegati-dipendente',
  templateUrl: './grid-allegati-dipendente.component.html',
  styleUrls: ['./grid-allegati-dipendente.component.scss'],
  imports: [
    DxPopupComponent,
    DxDataGridComponent,
    DxTemplateDirective,
    PopupAddAllegatoDipendenteComponent,
    DxPopupComponent,
    DxiColumnComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoExportComponent
  ],
  standalone: true,
})
export class GridAllegatiDipendenteComponent
  extends GestArticoliBaseComponent
  implements OnChanges
{
  private sanitizer = inject(DomSanitizer);
  private allegatiService = inject(AllegatiDipendentiService);
  private ns = inject(NavigatorService);
  @Input() dipendente: Dipendente = new Dipendente();
  @Input() exportEnabled = true;

  dataSource: any;

  popupImageVisible = false;
  currentImage!: SafeResourceUrl;

  popupAddAllegatoDipendenteVisible = false;

  ngOnChanges() {
    if (this.dipendente) {
      this.loadData();
    }
  }

  loadData() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(
          this.allegatiService.listByDipendente(this.dipendente.id),
        )
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      remove: (key) => {
        return (
          firstValueFrom(this.allegatiService.delete(key))
            //.catch(() => { throw 'Deletion failed' });
            .then(() => console.log('delete eseguito'))
            .catch((error: HttpErrorResponse) => {
              if (error.status == 500) {
                throw error.error.title;
              } else {
                throw 'Deletion failed';
              }
            })
        );
      },
    });
  }

  scaricaFile(allegato: AllegatiDipendenti) {
    this.allegatiService.scarica(allegato.id).subscribe((res) => {
      FileSaver.saveAs(res, allegato.nomeFile);
    });
  }

  visualizzaFile(allegato: AllegatiDipendenti) {
    this.allegatiService.scarica(allegato.id).subscribe((res) => {
      const url = window.URL.createObjectURL(res);
      window.open(url);
    });
  }

  visualizzaImmagine(allegato: AllegatiDipendenti) {
    this.allegatiService.getImmagine(allegato.id).subscribe((res) => {
      this.currentImage = this.sanitizer.bypassSecurityTrustResourceUrl(
        'data:image;base64,' + res,
      );
      this.popupImageVisible = true;
    });
  }

  goToAllega(idArticolo: number) {
    this.ns.goToAllega(idArticolo);
  }

  endsWith(str: any, suffix: any) {
    if (str == undefined) {
      return false;
    }
    return (
      str
        .toUpperCase()
        .indexOf(suffix.toUpperCase(), str.length - suffix.length) !== -1
    );
  }

  onPopupAddAllegatoDipendenteEvent(e: any) {
    this.popupAddAllegatoDipendenteVisible = false;
    if (e) {
      this.loadData();
    }
  }

  onInitNewRow(e: any) {
    setTimeout(() => {
      e.component.cancelEditData();
    }, 100);
    this.popupAddAllegatoDipendenteVisible = true;
  }

  onExporting(e: any){
    const nomeFile = 'Allegati_' + this.dipendente.nominativo + '.xlsx' ;
    GridExportExcel(e, 'Allegati', nomeFile);
  }
}
